/**
 *
 */
const changeFeaturedGame = () => {
	const games = document.querySelectorAll('.games-gallery__item');
	const featuredGameIframe = document.querySelector('.featured-game__holder iframe');
	if (featuredGameIframe && games.length > 0) {
		games.forEach((game) => {
			
			game.addEventListener('click', (evt) => {
				if (game.dataset.url && !game.classList.contains('games-gallery__item--active')) {
					featuredGameIframe.src = game.dataset.url;
					window.scrollTo(0, 72);
					
					games.forEach((gameInner) => {
						if (gameInner.classList.contains('games-gallery__item--active')) {
							gameInner.classList.remove('games-gallery__item--active')
						}
					});
					
					game.classList.add('games-gallery__item--active');
				}
			});
		});
	}
};

export default changeFeaturedGame;
